import sectionSatelliteGridCss from '../css-snippets/section-grid-satellite';
import dividerPrimaryRawHtml from '../../../views/website/products/components/description/ui-modules/divider-primary/raw-html';

const dividerPrimary = dividerPrimaryRawHtml({
  show: false,
  maxWidth: 200,
  height: 6,
  backgroundColor: '#5B04DE',
  align: 'center',
});

const html = `
<style>${sectionSatelliteGridCss}</style>
<div data-attribute="satellite-grid-container" data-top-padding="true" data-bottom-padding="true">
   <div class="wrap-satellite-grid container">
      <div class="header-satellite">
         <div data-attribute="main-title-satellite" class="title-satellite"><h2><strong>Drive clean, calm &amp; carefree 🐾🚗</strong></h2><p>No more messy rides. Just smooth, stress-free travel.</p></div>
         ${dividerPrimary}
      </div>
      <div class="body-satellite">
         <div class="wrap-item-satellite">
            <div data-attribute="items-left" class="items-left">
               <div data-attribute="item-satellite" class="item-satellite">
                  <div class="wrap-img">
                     <img loading="lazy" data-attribute="satellite-image" class="satellite-image" src="https://cdn.cacheimg.com/Admin-Lattehub/2025/08/06/image-6892fe4610a7b13b8ea13bbd.png?w=50" alt="">
                  </div>
                  <h2 data-attribute="title-satellite" class="title-satellite">Hard Bottom Support</h2>
                  <p data-attribute="description-satellite" class="description-satellite">No more sagging or slipping—the solid base keeps big dogs steady and secure on every ride.</p>
               </div>
               <div data-attribute="item-satellite" class="item-satellite">
                  <div class="wrap-img">
                     <img loading="lazy" data-attribute="satellite-image" class="satellite-image" src="https://cdn.cacheimg.com/Admin-Lattehub/2025/08/06/image-6892fe64d8698d53b9f69528.png?w=50" alt="">
                  </div>
                  <h2 data-attribute="title-satellite" class="title-satellite">100% Waterproof</h2>
                  <p data-attribute="description-satellite" class="description-satellite">Blocks mud, fur, and spills with 4-layer protection. Just wipe it clean.</p>
               </div>
            </div>
            <div data-attribute="items-center" class="items-center">
               <div data-attribute="item-satellite" class="item-satellite">
                  <div class="wrap-img">
                     <img loading="lazy" data-attribute="satellite-image" class="satellite-image" src="https://cdn.cacheimg.com/Admin-Lattehub/2025/08/06/image-6892fdf4c8b8a7bcd9fb42f6.png?w=500" alt="">
                  </div>
                  <div data-attribute="title-satellite" class="title-satellite">
                    <h2>
                      <strong>Drive clean, calm &amp; carefree 🐾🚗</strong>
                    </h2>
                    <p> No more messy rides. Just smooth, stress-free travel.</p>
                  </div>
               </div>
            </div>
            <div data-attribute="items-right" class="items-right">
               <div data-attribute="item-satellite" class="item-satellite">
                  <div class="wrap-img">
                     <img loading="lazy" data-attribute="satellite-image" class="satellite-image" src="https://cdn.cacheimg.com/Admin-Lattehub/2025/08/06/image-6892fe9395e4d7f6ec8247a8.png?w=50" alt="">
                  </div>
                  <h2 data-attribute="title-satellite" class="title-satellite">3-in-1 Convertible Design</h2>
                  <p data-attribute="description-satellite" class="description-satellite">Switch between hammock, bench, or cargo mode. Fits any car with adjustable straps.</p>
               </div>
               <div data-attribute="item-satellite" class="item-satellite">
                  <div class="wrap-img">
                     <img loading="lazy" data-attribute="satellite-image" class="satellite-image" src="https://cdn.cacheimg.com/Admin-Lattehub/2025/08/06/image-6892feb5565e07ee8c24c7c8.png?w=50" alt="">
                  </div>
                  <h2 data-attribute="title-satellite" class="title-satellite">Anxiety-Reducing Mesh Window</h2>
                  <p data-attribute="description-satellite" class="description-satellite">Your dog stays calm and connected, thanks to the breathable window that lets them see you.</p>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
`;
export default html;
